import React, { useState } from "react";
import { ReactComponent as DownloadIcon } from "../assets/images/download1.svg";
import { ReactComponent as DeleteIcon } from "../assets/images/delete-icon.svg";
import { CloseOutlined, EyeOutlined, LeftOutlined } from "@ant-design/icons";
import { AttechmentType } from "../Common/constant";
import moment from "moment";
import { StyledTable } from "./UITable/UITable";
import { CALL_API } from "../Common/api";
import UIModal from "./UIModal";
import ReusableDrawer from "./ReusableDrawer";
import { Spin } from "antd";
import download from "downloadjs";
import { ReactComponent as MapIcon } from "../assets/images/Group 1000004561.svg";
import MapComponent from "../Reusablecomponents/MapComponent";
import { ButtonFilled, Buttontransparent } from "./UIButtons";
import dayjs from "dayjs";

const FilesTable = ({ filesList, getFileData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileURL, setFileURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [mapicon, setMapicon] = useState(false);
  const [mapCoords, setMapCoords] = useState({ lat: null, lng: null });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [locationList, setLocationList] = useState([]);

  const handlemapicon = () => {
    setIsModalOpen(true);
  };

  const handleClosecontainer = () => {
    setIsModalOpen(false);
  };

  const handleopen = (id) => {
    setIsDeleteModalVisible(true);
  };

  const filesColumn = [
    {
      title: "Title",
      dataIndex: "TITLE",
      key: "TITLE",
      render: (_, record) => (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MapIcon
                onClick={handlemapicon}
                style={{
                  width: "24px",
                  height: "24px",
                  cursor: "pointer",
                  marginLeft: "15px",
                  marginBottom: "15px"
                }}
              />
            </span>
            <p>{record?.TITLE}</p>
          </div>
        </>
      ),
    },
    {
      title: "File Size",
      dataIndex: "FSIZE", // assuming FSIZE is in bytes
      key: "FSIZE",
      render: (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
        else if (bytes < 1024 * 1024 * 1024)
          return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
        else return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      },
    },
    {
      title: "File Type",
      dataIndex: "MTYPE",
      key: "MTYPE",
      render: (_, record) => {
        const fileExtension = record?.TITLE?.split(".").pop()?.toLowerCase();

        if (["docx", "xlsx"].includes(fileExtension)) {
          return "Document";
        } else if (fileExtension === "pdf") {
          return "PDF";
        } else if (["png", "jpg", "jpeg"].includes(fileExtension)) {
          return "Image";
        } else {
          return "Unknown";
        }
      },
    },
    {
      title: "Added By",
      dataIndex: "AddedBy",
      key: "AddedBy",
      render: (text, record) => (
        <>
          <div className="consingment_container_record">
            <p>{record?.AddedBy}</p>
            <i style={{ color: "#8492B1" }}>
              {dayjs(record?.CRON).format("Do MMM YYYY; hh:mm A")}
            </i>
          </div>
        </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => {
        const fileExtension = record?.TITLE?.split(".").pop().toLowerCase(); // Extract file extension

        return (
          <>
            <div className="consingment_container_two">
              {fileExtension !== "pdf" &&
                fileExtension !== "docx" &&
                fileExtension !== "xlsx" && (
                  <EyeOutlined
                    style={{
                      marginRight: "13px",
                      fontSize: "17px",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleView(record?.ATTID);
                    }}
                  />
                )}
              <DownloadIcon
                loading={loading}
                style={{ marginRight: "13px", cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(record);
                }}
              />
              <DeleteIcon
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFileId(record?.ATTID);
                  handleopen(record?.ATTID);
                }}
              />
            </div>
          </>
        );
      },
    },
  ];

  const handleView = async (id) => {
    const { data } = await CALL_API(
      "GET",
      `common/GetFileOperation?attId=${id}`,
    );
    setIsOpen(true);
    setFileURL(data?.ImageURL);
  };

  const downloadFileWithWatermark = async (
    id,
    watermarkText = "Location - Time",
  ) => {
    try {
      setLoading(true);

      const { data } = await CALL_API(
        "GET",
        `common/GetFileOperation?attId=${id}`,
      );
      const fileUrl = data?.ImageURL;
      const fileName = data?.TITLE || `download_${id}`;
      const fileExtension = fileName.split(".").pop().toLowerCase();

      // Use XMLHttpRequest — handles S3 presigned URLs better than fetch
      const blob = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", fileUrl, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) resolve(xhr.response);
          else reject(new Error(`XHR failed: ${xhr.status}`));
        };
        xhr.onerror = () => reject(new Error("XHR network error"));
        xhr.send();
      });

      if (["jpg", "jpeg", "png"].includes(fileExtension)) {
        const objectUrl = URL.createObjectURL(blob);
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = objectUrl;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0);

          const fontSize = Math.max(16, canvas.width * 0.02);
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
          ctx.shadowColor = "white";
          ctx.shadowBlur = 1;
          ctx.fillText(watermarkText, 20, canvas.height - 20);

          canvas.toBlob((canvasBlob) => {
            download(canvasBlob, fileName, "image/jpeg");
            URL.revokeObjectURL(objectUrl);
            setLoading(false);
          }, "image/jpeg");
        };

        img.onerror = () => {
          download(blob, fileName);
          setLoading(false);
        };
      } else {
        download(blob, fileName);
        setLoading(false);
      }
    } catch (err) {
      console.error("Download failed", err);
      setLoading(false);
    }
  };

  const downloadFile = async (data) => {
    const timestamp = dayjs(data?.CRON).format("DD/MM/YYYY HH:mm:ss");
    let location = "Location unavailable";
    if (data?.Lat && data?.Lng) {
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${Number(data.Lat)}&lon=${Number(data.Lng)}&format=json`,
        );
        const geo = await res.json();
        const city =
          geo.address?.city || geo.address?.town || geo.address?.village || "";
        const country = geo.address?.country_code?.toUpperCase() || "";
        location = `${city}, ${country}`;
      } catch (err) {
        console.error("Error", err);
        location = "Location unavailable";
      }
    }

    const watermark = `${location} - ${timestamp}`;
    downloadFileWithWatermark(data?.ATTID, watermark);
  };

  const deleteFile = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("GET", `common/deleteFile?attId=${id}`);
    setLoading(false);
    getFileData();
    setIsDeleteModalVisible(false);
    // handleopen();
  };

  const handleCancel = () => {
    setIsOpen(false);
    setFileURL("");
  };

  return (
    <>
      <div>
        <Spin spinning={loading}>
          <StyledTable
            dataSource={filesList}
            pagination={false}
            columns={filesColumn}
          />
        </Spin>
        {/* <UIModal
        header=""
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeButton={false}
      >
        <div className="p-3">
          <iframe src={fileURL} width="100%" height="100%"></iframe>
        </div>
      </UIModal> */}
        <ReusableDrawer
          open={isOpen}
          setOpen={setIsOpen}
          children={
            <div className="p-3 w-100" style={{ height: "100vh" }}>
              <Spin spinning={loading}>
                <iframe
                  src={fileURL}
                  width="100%"
                  style={{ height: "80vh" }}
                ></iframe>
              </Spin>
            </div>
          }
        />
      </div>
      <div>
        {" "}
        <UIModal
          width={500}
          customHeight={500}
          open={isModalOpen}
          onClose={handleClosecontainer}
          closeButton={false}
        >
          <MapComponent
            tripEvent={mapCoords}
            locationsTL={filesList}
            fromFiles={true}
            // MapCoords={true}
          />
        </UIModal>
        <UIModal
          width={500}
          open={isDeleteModalVisible}
          onClose={() => {
            setIsDeleteModalVisible(false);
          }}
          closeButton={false}
          size="md"
          header={false}
          footer={false}
        >
          <div className="text-center">
            <h1>Are you sure,</h1>
            <h6>You want to delete this File?</h6>
            <div className="mt-2 w-100 d-flex justify-content-center">
              <ButtonFilled
                onClick={() => {
                  setIsDeleteModalVisible(false);
                  deleteFile(selectedFileId);
                  // Close the modal
                }}
              >
                Yes
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsDeleteModalVisible(false);
                }}
              >
                No
              </Buttontransparent>
            </div>
          </div>
        </UIModal>
      </div>
    </>
  );
};

export default FilesTable;
